import SiteUpsertDto from "../components/Common/dtos/SiteUpsertDto";
import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useUser } from "../components/UserAccess/useUser";

const useUpdateSite = (siteId: string, options?: RequestOptions) => {
  const user = useUser();

  return useUserRequest<SiteUpsertDto>({
    method: HttpMethod.PUT,
    path: `/api/businesses/${user.selectedBusiness?.id!}/sites/${siteId}` },
    options);
}

export default useUpdateSite;
